<template>
  <div>
    <el-card shadow="never">
      <Notes
        ref="notes"
        resource="account"
        :identifier="$route.params.accountId"
        truncate
        paginate
        :limit="10"
      />
    </el-card>
  </div>
</template>

<script>
import Notes from '@/components/Notes'
import { CREATE } from '@/plugins/user'
export default {
  components: {
    Notes
  },
  data () {
    return {
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'account_note'),
          name: 'New Note',
          icon: ['fal', 'plus'],
          event: () => {
            this.$refs.notes.create()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.$refs.notes.reload()
          }
        }
      ],
      breadcrumb: {
        name: 'Notes',
        route: { name: 'manage-accounts-account-notes', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
